const carouselItems = [
  {
    title: '暑期追剧指南',
    subtitle: '这个夏天必看的十部好剧',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20scene%20with%20cozy%20living%20room%20and%20TV%20screen%20displaying%20colorful%20movie%20thumbnails%2C%20soft%20golden%20hour%20lighting%2C%20comfortable%20home%20entertainment%20atmosphere%2C%20coral%20and%20amber%20warm%20tones%2C%20minimalist%20interior%20design%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field&width=720&height=400&seq=carousel-card-01&orientation=landscape',
  },
  {
    title: '科幻迷的终极片单',
    subtitle: '从经典到新作，一次看过瘾',
    tag: '主题策划',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20concept%20with%20floating%20holographic%20movie%20screens%20in%20dark%20space%2C%20neon%20coral%20and%20amber%20light%20accents%2C%20cinematic%20atmosphere%2C%20abstract%20geometric%20shapes%2C%20professional%20digital%20art%20style%2C%20clean%20composition%20with%20depth%2C%20entertainment%20technology%20theme&width=720&height=400&seq=carousel-card-02&orientation=landscape',
  },
  {
    title: '悬疑剧场：烧脑合集',
    subtitle: '反转不断的高分悬疑剧推荐',
    tag: '专题推荐',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20warm%20desk%20lamp%20lighting%2C%20case%20files%20and%20magnifying%20glass%20on%20wooden%20desk%2C%20film%20noir%20atmosphere%20with%20coral%20and%20amber%20color%20grading%2C%20professional%20cinematic%20photography%2C%20shallow%20depth%20of%20field%2C%20dramatic%20shadows&width=720&height=400&seq=carousel-card-03&orientation=landscape',
  },
  {
    title: '动漫频道：新番速递',
    subtitle: '七月新番大盘点，追番必备',
    tag: '新番推荐',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20vibrant%20warm%20gradient%20background%2C%20dynamic%20character%20silhouettes%20in%20action%20poses%2C%20Japanese%20animation%20aesthetic%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20digital%20art%20composition%2C%20clean%20and%20energetic%20style&width=720&height=400&seq=carousel-card-04&orientation=landscape',
  },
  {
    title: '古装仙侠：画风绝美',
    subtitle: '服化道在线的古装大剧精选',
    tag: '古风推荐',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20style%20scene%20with%20flowing%20silk%20fabrics%20and%20ancient%20architecture%20silhouette%2C%20warm%20golden%20sunset%20lighting%2C%20misty%20mountain%20background%2C%20cinematic%20widescreen%20composition%2C%20coral%20and%20amber%20color%20tones%2C%20professional%20film%20photography%20aesthetic&width=720&height=400&seq=carousel-card-05&orientation=landscape',
  },
  {
    title: '周末电影马拉松',
    subtitle: '从早看到晚的精选片单',
    tag: '周末精选',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20movie%20title%2C%20soft%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20with%20blankets%2C%20popcorn%20bowl%2C%20weekend%20relaxation%20vibe%2C%20coral%20and%20amber%20warm%20tones%2C%20editorial%20lifestyle%20photography&width=720&height=400&seq=carousel-card-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-layout-masonry-line"></i>
            <span className="whitespace-nowrap">编辑甄选</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">精选专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精心策划的影视专题，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-800 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}